import { SET_ASSESSMENT_INFO } from 'redux/actions/actionTypes';
const initialState = {
  assessmentName: '',
  urlAssessmentName: '',
};

export default (state = initialState, { payload, type }) => {
  switch (type) {
    case SET_ASSESSMENT_INFO: {
      return {
        ...state,
        ...payload,
      };
    }
    default:
      return state;
  }
};
